// BootstrapStarterCardUtilities.js

import { useEffect } from 'react';

// Hook to handle outside clicks and hide menus
export const useCardMenuEffectPerRow = (openMenus, setOpenMenus) => {
    useEffect(() => {
        const hideMenusOnClickOutside = (event) => {
            // Collect all active tool menu containers
            const menuElements = document.querySelectorAll('.cardOptions, .tagApplier');

            // Check if the clicked element is inside any open menu
            const clickedInsideMenu = Array.from(menuElements).some(menu =>
                menu.contains(event.target)
            );

            if (!clickedInsideMenu) {
                setOpenMenus({});
            }
        };

        document.addEventListener('mousedown', hideMenusOnClickOutside);
        return () => {
            document.removeEventListener('mousedown', hideMenusOnClickOutside);
        };
    }, [openMenus, setOpenMenus]);
};



// Function to toggle a menu open or closed
export const handleToggleMenu = (menuType, setOpenMenu, hideAllTools) => {
    setOpenMenu(prev => {
        const isSameMenu = prev === menuType;
        const isMobile = window.innerWidth <= 767.98;

        if (!isSameMenu && isMobile) {
            hideAllTools(); // Only hide tools in mobile view
        }

        return isSameMenu ? null : menuType;
    });
};


// Function to hide all card menus on mobile only
export const hideAllCardMenusMobileViewOnly = (setOpenMenu, setOpenMenus) => {
    if (window.innerWidth <= 767.98) {
        setOpenMenu(null);
        setOpenMenus({}); // <-- clear all openMenus by row
        console.log('hideAllCardMenusMobileViewOnly: Menus hidden for mobile view');
    }
};
